import { ReactElement } from "react";
import "./App.css";
import { InteractionType, IPublicClientApplication } from "@azure/msal-browser";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { Box } from "@mui/material";
import { MainController } from "./MainController";
import { ApplicationState } from "./utils/ApplicationState";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { NavigationBar } from "./home/ui-components/NavigationBar";
import "./Common/UI/styles/gridScrollbar.css";
import { ErrorProvider } from "./Events/UI/ErrorContext";
import { SpiritNightTransitionProvider, SpiritNightTransitionBanner } from "./home/ui-components/SpiritNightTransition";
import { BreadcrumbsBar } from "./home/ui-components/BreadcrumbsBar";

const App = ({ instance }: { instance: IPublicClientApplication }): ReactElement => {
  // // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  // const navigate = useNavigate();
  // const navigationClient = new CustomNavigationClient(navigate);
  // pca.setNavigationClient(navigationClient);
  // const { instance } = useMsal();

  const mainController = MainController();
  const router = createBrowserRouter(mainController.getRoutesConfig());
  const navBarMenuItems = mainController.getMenuItems();

  return (
    // <React.StrictMode>
    <ApplicationState>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MsalProvider instance={instance}>
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <ErrorProvider>
              <SpiritNightTransitionProvider>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <NavigationBar menuItems={navBarMenuItems} />
                  <SpiritNightTransitionBanner />
                  <BreadcrumbsBar />
                  <Box sx={{ flex: 1, width: "100%" }}>
                    <RouterProvider router={router} />
                  </Box>
                </Box>
              </SpiritNightTransitionProvider>
            </ErrorProvider>
          </MsalAuthenticationTemplate>
        </MsalProvider>
      </LocalizationProvider>
    </ApplicationState>
    // </React.StrictMode>
  );
};

export default App;
